"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "maracalagonis": {
    "13fd3bc8": [{
      "hkey": "bfa4129e",
      "slug": "baccu-mandara-torre-delle-stelle",
      "name": "Baccu Mandara-Torre delle Stelle",
      "primary": true,
      "skipSearch": false
    }],
    "baccu-mandara": [{
      "hkey": "bfa4129e",
      "slug": "baccu-mandara-torre-delle-stelle",
      "name": "Baccu Mandara-Torre delle Stelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "264c4099": [{
      "hkey": "bfa4129e",
      "slug": "baccu-mandara-torre-delle-stelle",
      "name": "Baccu Mandara-Torre delle Stelle",
      "primary": true,
      "skipSearch": false
    }],
    "torre-delle-stelle": [{
      "hkey": "bfa4129e",
      "slug": "baccu-mandara-torre-delle-stelle",
      "name": "Baccu Mandara-Torre delle Stelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "maracalagonis"
    }],
    "441eae42": [{
      "hkey": "b6c95ba9",
      "slug": "maracalagonis",
      "name": "Maracalagonis",
      "primary": true,
      "skipSearch": false
    }],
    "su-reu": [{
      "hkey": "b6c95ba9",
      "slug": "maracalagonis",
      "name": "Maracalagonis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;